import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageFormComponent } from '../page-form/page-form.component';
import {typeEvents} from '../../../common/enum/type-events';
import {PubSubService} from '../../../common/services/pub-sub.service';
import { MatDialog } from '@angular/material/dialog';
import {PagePreviewComponent} from '../page-preview/page-preview.component';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'p8-bdc-page-edit',
  templateUrl: './page-edit.component.html',
  styleUrls: ['./page-edit.component.scss']
})
export class PageEditComponent implements OnInit {
  @ViewChild(PageFormComponent, { static: true }) pageFormComponent: PageFormComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private pubSubSvc: PubSubService
  ) { }

  ngOnInit() {

  }

  onSubmit() {
    this.pubSubSvc.publish('loading', true);
    this.pageFormComponent.save()
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(page => {
        this.pubSubSvc.publish(typeEvents.pageSaved, 'la page a bien été sauvegardée');

      // this.router.navigate(['../..'], {relativeTo: this.activatedRoute});
    });
  }

  onCancel() {
    this.router.navigate(['../..'], {relativeTo: this.activatedRoute});
  }

  onVisualize() {
    const data = {id: this.activatedRoute.snapshot.params['id']};
    const modalIcon = this.dialog.open(PagePreviewComponent, {data: data});
    modalIcon.updateSize('750px', '650px');
  }
}
